import axios from "axios";
import { BACKEND_URL } from "../baseUrl";
import { store } from "../store/store";
import { canImpersonate, getViewAsUser } from "./ViewAsService";

const axiosInstance = axios.create({
  baseURL: BACKEND_URL,
});

axiosInstance.interceptors.request.use((config) => {
  if (config.url.includes("v1/")) {
    const state = store.getState();
    const token = state.auth.auth.idToken;
    config.headers["Authorization"] = `bearer ${token}`;

    const viewAsUser = getViewAsUser();
    if (
      viewAsUser &&
      canImpersonate(state.auth.auth) &&
      (config.method || "get").toLowerCase() === "get" &&
      /v1\/(assesment|assignment)/.test(config.url)
    ) {
      config.params = { ...(config.params || {}), viewAs: viewAsUser.id };
    }
  }
  return config;
});

export default axiosInstance;
